import { render, staticRenderFns } from "./TokenExpiredView.vue?vue&type=template&id=49b9de0a"
import script from "./TokenExpiredView.vue?vue&type=script&lang=js"
export * from "./TokenExpiredView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports